export default __webpack_public_path__ + "static/media/moscowSport-little.4575fc61.png";